import { api } from "./apiClient";

export const crmService = {
  meta: async () => (await api.get("/manager/crm/meta")).data,
  statusCounts: async () => (await api.get("/manager/crm/status-counts")).data,
  setStatus: async (id, crm_status) =>
    (await api.post(`/manager/clients/${id}/status`, { crm_status })).data,
  statusHistory: async (id) => (await api.get(`/manager/clients/${id}/status-history`)).data,
};
